export function getVehicleImageServiceEndpoint(encryptedVin: string): string {
    return `/vehicle-image-service/vehicle/${encryptedVin}`;
}
